import {
    getPropertySummary,
    getPropertyCountByMonth,
    getPropertyCountByState,
    getPropertyCountByDistrict
} from '../../../services/ReportService';
import {
    CONFIRMED_GET_PROPERTY_SUMMARY,
    CONFIRMED_GET_PROPERTY_COUNT_BY_MONTH,
    CONFIRMED_GET_PROPERTY_COUNT_BY_STATE,
    CONFIRMED_GET_PROPERTY_COUNT_BY_DISTRICT
} from './ReportTypes';

export function getPropertySummaryAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        getPropertySummary(currentPage, pageSize, searchTerm, filterQuery).then((response) => {
            dispatch(confirmedGetPropertySummaryAction(response.data.data));
        });
    };
}

export function confirmedGetPropertySummaryAction(data) {
    return {
        type: CONFIRMED_GET_PROPERTY_SUMMARY,
        payload: data,
    };
}

export function getPropertyCountByMonthAction() {
    return (dispatch, getState) => {
        getPropertyCountByMonth().then((response) => {
            dispatch(confirmedGetPropertyCountByMonthAction(response.data.data));
        });
    };
}

export function confirmedGetPropertyCountByMonthAction(data) {
    return {
        type: CONFIRMED_GET_PROPERTY_COUNT_BY_MONTH,
        payload: data,
    };
}

export function getPropertyCountByStateAction() {
    return (dispatch, getState) => {
        getPropertyCountByState().then((response) => {
            dispatch(confirmedGetPropertyCountByStateAction(response.data.data));
        });
    };
}

export function confirmedGetPropertyCountByStateAction(data) {
    return {
        type: CONFIRMED_GET_PROPERTY_COUNT_BY_STATE,
        payload: data,
    };
}

export function getPropertyCountByDistrictAction(stateName) {
    return (dispatch, getState) => {
        getPropertyCountByDistrict(stateName).then((response) => {
            dispatch(confirmedGetPropertyCountByDistrictAction(response.data.data));
        });
    };
}

export function confirmedGetPropertyCountByDistrictAction(data) {
    return {
        type: CONFIRMED_GET_PROPERTY_COUNT_BY_DISTRICT,
        payload: data,
    };
}
